import React, { Fragment, useEffect, useState } from 'react';
import SettingsContainer from 'containers/SettingsContainer';
import MapWrapper from 'components/Map/MapWrapper';
import Unavailable from 'components/Shared/Unavailable';
import { FixedLargeMobileBanner } from 'components/Shared/Ads/FixedLargeMobileBanner';
import { routes } from 'modules/routes';
import { useRoute } from 'wouter';
import { useRecoilState, useRecoilValue } from 'recoil';
import { currentMapIdState, currentMapSelector } from 'modules/map';
import { setCurrentMap } from 'modules/reset';
import { push } from 'utils/push';
import { SaveMapStateOnUnload } from 'components/Map/SaveMapStateOnUnload';
import { useDispatch, useSelector } from 'react-redux';
import { clearState, loadState } from 'modules/storage';
import notify from 'utils/notify';
import { currentUserIsUpgradedUserSelector } from 'modules/currentUser';

const parseId = (id) => {
    if (!id) {
        return null;
    }
    const int = parseInt(id, 10);
    return isNaN(int) ? null : int;
};

export default function MapBuilder() {
    const [match, params] = useRoute(routes.mapBuilderEdit.path);
    const [currentMapId, setCurrentMapId] = useRecoilState(currentMapIdState); // eslint-disable-line no-unused-vars
    const map = useRecoilValue(currentMapSelector);
    const dispatch = useDispatch();

    useEffect(() => {
        setCurrentMapId(match ? parseId(params.id) : null);
    }, [setCurrentMapId, match, params]);

    const [loadedState, setLoadedState] = useState(false);
    useEffect(() => {
        const localState = loadState();
        if (localState) {
            clearState();
            setLoadedState(true);
            dispatch(setCurrentMap(localState.map));
        } else {
            if (!loadedState) {
                dispatch(setCurrentMap(map));
            }
        }
        if (!map && currentMapId) {
            notify.error('Unable to access the requested map. Please contact support if the problem continues.');
            push(routes.mapBuilder.path);
        }
    }, [dispatch, map, currentMapId, loadedState]);
    const isUpgradedUser = useSelector(currentUserIsUpgradedUserSelector);

    return (
        <Fragment>
            <SaveMapStateOnUnload />
            <Unavailable />
            <SettingsContainer />
            <MapWrapper />
            {!isUpgradedUser && <FixedLargeMobileBanner id="map-builder-ad" width={320} height={100} />}
        </Fragment>
    );
}
